'use strict';

var processInclude = require('base/util');

$(() => {
    processInclude(require('./search/search'));
    processInclude(require('./criteo/criteo'));
});
